import { ASSETS, Chapter, Reveal } from "../presentation";

export default function S07Brabus55() {
  return (
    <section id="brabus-55" className="about-immersive immersive-right theme-dark" data-testid="slide-brabus-55">
      <div className="about-immersive-media" data-testid="brabus-media">
        <video src={ASSETS.brabusVideo} poster={ASSETS.brabusPoster} autoPlay muted loop playsInline aria-label="Sunreef BRABUS Ultima 55" />
      </div>
      <div className="about-immersive-scrim" />
      <div className="about-immersive-grain" />

      <div className="about-immersive-inner">
        <div className="sec-topbar" style={{ marginBottom: 0 }}>
          <Chapter ch="06" label="brabus ultima 55" testid="brabus-chapter" />
          <span className="wordmark wordmark-sm">SUNREEF</span>
        </div>

        <div className="about-immersive-content">
          <Reveal><span className="eyebrow">.brabus ultima 55</span></Reveal>
          <Reveal delay={1}>
            <h2 className="editorial editorial-lg" data-testid="brabus-headline">
              Sunreef × <span className="gold">BRABUS.</span>
            </h2>
          </Reveal>

          <Reveal delay={2}>
            <p className="body-prose" data-testid="brabus-lede">
              First exclusive product of the collaboration: high-performance technology.
            </p>
          </Reveal>

          <Reveal className="bullet-list bullet-list-onimage" as="ul" delay={2} testid="brabus-list">
            <li data-testid="brabus-bullet-1">55-foot luxury foiling catamaran</li>
            <li data-testid="brabus-bullet-2">A signature BRABUS carbon-fiber design concept</li>
          </Reveal>

          <Reveal className="stat-row" delay={3} testid="brabus-stats">
            <div className="stat">
              <span className="stat-num">40<span className="stat-unit">+kn</span></span>
              <span className="stat-label">.top speed</span>
            </div>
            <div className="stat">
              <span className="stat-num">04</span>
              <span className="stat-label">.units sold</span>
            </div>
            <div className="stat">
              <span className="stat-num">03</span>
              <span className="stat-label">.units under construction</span>
            </div>
          </Reveal>
        </div>

        <div className="about-immersive-foot">
          <span className="about-caption about-caption-corner" aria-hidden="true"></span>
        </div>
      </div>
    </section>
  );
}
